import React from 'react'
import PricingSection from '../components/PricingSection'
import NavbarComponent from '../components/NavbarComponent'
import FooterSection from '../components/FooterSection'

function PricingPage() {
    return (
        <>
            <NavbarComponent />
            <PricingSection />
            <FooterSection />
        </>
    )
}

export default PricingPage
